import { formatTablePayload } from "../../../common/utils";
import { userClient, baseClient, authClient } from "../../../services/api/apiClient";

export const getRequestVerificationList = (tableParams, status) => {
  const data = {
    ...formatTablePayload(tableParams),
    status: status,
  };
  return userClient.post(`/request-verification-admin`, data);
};

export const getRequestVerificationDetailsById = (id) =>
  userClient.get(`/request-verification/${id}`);

export const getRequestVerificationListByStatus = (status) =>
  userClient.get(`/request-verification?status=${status}`);

export const updateRequestVerificationStatus = (id, data) =>
  userClient.patch(`/request-verification/${id}`, data);

export const getNationality = () => authClient.get(`/nationality-list`);

export const getCategories = () =>
  userClient.get(`/request-verification-list`);
